import React from "react";
import { I18nProvider } from "@lingui/react";
import { i18n } from "@lingui/core";
import { fr, nl } from "make-plural/plurals";

i18n.loadLocaleData({
  fr: { plurals: fr },
  nl: { plurals: nl },
});
export interface Props {
  language: string;
}
export const I18nContextProvider: React.FC<Props> = ({ language, children }) => {
  const [loaded, setLoaded] = React.useState(false);

  React.useEffect(() => {
    const loadCatalog = async (locale: string) => {
      const catalog = await import(
        /* webpackMode: "lazy", webpackChunkName: "i18n-[index]" */
        `@lingui/loader!../locales/${locale}/messages.po`
      );

      i18n.load(locale, catalog.messages);
      i18n.activate(locale);
      setLoaded(true);
    };
    loadCatalog(language);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language]);

  if (!loaded) return <div />;

  return (
    <I18nProvider i18n={i18n} forceRenderOnLocaleChange={false}>
      {children}
    </I18nProvider>
  );
};

I18nContextProvider.displayName = "I18nContextProvider";
